import { Helmet } from "react-helmet-async"
import { useOutletContext } from "react-router"
import {
	TTouristProfile,
	TouristProfileDocuments,
} from "../../../../TouristProfiles"

export default function TouristProfileDocumentsPage() {
	const { touristProfile } = useOutletContext<{
		touristProfile: TTouristProfile
	}>()
	return (
		<>
			<Helmet>
				<title>Tourist Profile Documents</title>
			</Helmet>
			<TouristProfileDocuments touristProfile={touristProfile} />
		</>
	)
}
